<mat-form-field class="workout-list" fxFlex>
  <mat-select [formControl]="workoutControl">
    <mat-option *ngFor="let item of workoutList" [value]="item.id">
      <div fxFlex fxLayout="row" fxLayoutAlign="start center">
        <div>{{ item.title }}</div>
        <div fxFlex></div>
        <mat-chip *ngIf="item.complete" [selectable]="false" style="background-color: green; color: #fff;">&nbsp;Complete</mat-chip>
      </div>
    </mat-option>
    <mat-option *ngIf="canEdit" value="null">Add Workout</mat-option>
  </mat-select>
</mat-form-field>
